export default "__VITE_ASSET__u7FyMAaj__"